class DynamicUrlValues extends HTMLElement {
	constructor() {
		super();

		this.originalValue = this.innerHTML;
		this.type = this.getAttribute('type');
	}

	render() {
		let storageItem = sessionStorage.getItem('code'),
			codeID =
				storageItem != null
					? storageItem
					: new URL(location.href).searchParams.get('code'),
			dynamicUrlObj = window.dynamicUrl;

		if (
			dynamicUrlObj == undefined ||
			codeID == null ||
			Object.keys(dynamicUrlObj).length < 1 ||
			dynamicUrlObj[codeID] == undefined
		) {
			this.style.opacity = '1';
			return;
		}

		switch (this.type) {
			case 'header-top-message':
				this.innerHTML = dynamicUrlObj[codeID].header_top_message;
				break;
			case 'badge-phrase':
				this.innerHTML = dynamicUrlObj[codeID].badge_phrase;
				break;
			case 'product-sub-title':
				this.innerHTML = dynamicUrlObj[codeID].product_sub_title;
				break;
			default:
				this.innerHTML = this.originalValue;
		}

		this.style.opacity = '1';

		if (storageItem == null) sessionStorage.setItem('code', codeID);
	}

	connectedCallback() {
		this.render();
	}
}

customElements.define('dynamic-url-values', DynamicUrlValues);

// =-=-= Cart coupon code form =-=-=-
// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
class CouponCodeForm extends HTMLElement {
	constructor() {
		super();

		this.placeholder = this.getAttribute('placeholder').replace(
			'"',
			'&quot;'
		);
		this.isHidden =
			this.getAttribute('is-hidden') == 'true' ? 'hidden' : '';

		this.couponCodeData = {
			codeInput: null,
			codeFound: null, // response.discount_code
			totalDiscount: null, // response.total_discount_amount
			totalPrice: null, // response.total_line_items_price
			totalDiscountedPrice: null, // response.total_price
			nonApplicable: null,
			hasError: false,
			errorMessage: 'Invalid discount code',
			loading: false,
		};
	}

	async clearCouponCode() {
		this.couponCodeData.codeInput = null;
		this.couponCodeData.codeFound = null;
		this.couponCodeData.totalDiscount = null;
		this.couponCodeData.totalPrice = null;
		this.couponCodeData.totalDiscountedPrice = null;
		this.couponCodeData.nonApplicable = null;

		this.clearCouponCodeStorage();

		this.renderHTML();

		document.cookie =
			'discount_code=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

		try {
            //remove discount
			//await fetch('/discount/clear', {});
                                  const cartRes = await fetch('/cart.js', {});
                                  let cart = await cartRes.json();
                                  //console.log(cart);
                                  let token = cart.token;
                                  let v = {
                                    "cartId": "gid://shopify/Cart/" + token,
                                    "discountCodes": [
                                      ''
                                    ]
                                  };
                                  let q = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                                    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                                      cart {
                                        discountCodes {
                                          code
                                          applicable
                                        }
                                      }
                                      userErrors {
                                        field
                                        message
                                      }
                                    }
                                  }`;
                                  const dRes = await fetch("/api/2025-07/graphql.json", {
                                    method:"POST",
                                    headers:{
                                      "Content-Type":"application/json",
                                    },
                                    body:JSON.stringify({
                                      query:q,
                                      variables:v
                                    })
                                  });
		} catch (e) {
			console.log(e);
		}

		if (document.querySelector('ajax-cart') !== null)
			document.querySelector('ajax-cart').getCartData(null, false);
	}

	clearCouponCodeStorage() {
		sessionStorage.removeItem('discountCode');
		sessionStorage.removeItem('discount');

		if (document.querySelector('#checkoutBtn') != null)
			document.querySelector('#checkoutBtn').href = '/checkout';
	}

	getCouponCodeStorage() {
		if (sessionStorage.discountCode == undefined) return false;

		let storageData = JSON.parse(sessionStorage.discountCode);

		this.couponCodeData.codeInput = storageData.code;
		this.couponCodeData.codeFound = storageData.codeFound;
		this.couponCodeData.totalDiscount = storageData.totalDiscount;
		this.couponCodeData.totalPrice = storageData.totalPrice;
		this.couponCodeData.totalDiscountedPrice =
			storageData.totalDiscountedPrice;
		this.couponCodeData.nonApplicable = storageData.nonApplicable;

		return true;
	}

	applyCouponCode() {
		if (sessionStorage.discount !== undefined) {
			this.couponCodeData.codeInput = sessionStorage.discount;
		} else if (this.couponCodeData.codeInput == null) {
			this.couponCodeData.codeInput = new URL(
				location.href
			).searchParams.get('discount');
		}

		if (
			this.couponCodeData.codeInput == null ||
			this.couponCodeData.codeInput == ''
		)
			return;

		this.couponCodeData.loading = true;
		if (document.querySelector('ajax-cart'))
			document.querySelector('ajax-cart').setAttribute('updating', true);

		if (this.querySelector('.btn-apply') !== null)
			this.querySelector('.btn-apply').classList.add('is-loading');

		const self = this,
			code =
				sessionStorage.discount !== undefined
					? sessionStorage.discount
					: this.couponCodeData.codeInput;

      if(code) {
        //update discount
        const obj = this;
        fetch('/cart.js', {}).then(function(res){return res.json();}).then(async function(data) {
          try {
            let cart = data;
            //console.log(cart);
            let token = cart.token;
            let v = {
              "cartId": "gid://shopify/Cart/" + token,
              "discountCodes": [
                code
              ]
            };
            let q = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
              cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                cart {
                  discountCodes {
                    code
                    applicable
                  }
                }
                userErrors {
                  field
                  message
                }
              }
            }`;
            fetch("/api/2025-07/graphql.json", {
              method:"POST",
              headers:{
                "Content-Type":"application/json",
              },
              body:JSON.stringify({
                query:q,
                variables:v
              })
            }).then(function(res){return res.json();}).then(async function(res) {
                fetch('/cart.js?view=discount', {}).then(function(res){return res.json();})
            .then(async function(data) {//console.log(data);
                        let currentCode = data && data.discount_codes.length > 0 ? data.discount_codes.filter(item => item.code.toUpperCase() === code.toUpperCase()) : {};
                        if (
							data !== undefined
							 && data.discount_codes.length > 0
                          && (currentCode[0].applicable == true || (currentCode[0].applicable == false && window.dynamicUrl && window.dynamicUrl[currentCode[0].code.toUpperCase()])) 
						) {
							sessionStorage.setItem(
								'discountCode',
								JSON.stringify({
									code: code.trim(),
									codeFound: currentCode[0].code,
									totalDiscount:
										data.total_discount,
									totalPrice:
										data.original_total_price,
									totalDiscountedPrice:
										data.total_price,
									nonApplicable:
										data.discount_codes
											.length > 0 &&
										currentCode[0]
											.applicable ==
											false && window.dynamicUrl && window.dynamicUrl[currentCode[0].code.toUpperCase()]
											? `Before using code <strong style="text-transform:uppercase">${currentCode[0].code}</strong> please add all items to cart`
											: null,
								})
							);

							sessionStorage.setItem(
								'discount',
								currentCode[0].code
							);

							self.getCouponCodeStorage();

							// Cover coupon code "Buy 1 get 1" type
							if (self.couponCodeData.nonApplicable !== null) {
								document.querySelector(
									'ajax-cart [data-carttotal]'
								).innerHTML = `<span class="money">${self.formatMoney(
									window.globalVariables.cart.total_price,
									true
								)}</span>`;

								self.clearCouponCodeStorage();

								if (self.querySelector('.text-danger') == null)
									return;

								if (
									window.globalVariables.cart.items.length >
										0 &&
									currentCode[0].code == 'MTFREE' &&
									document.querySelector(
										'modal-discount-code'
									) !== null
								)
									document
										.querySelector('modal-discount-code')
										.open();

								setTimeout(() => {
									self.querySelector(
										'.text-danger'
									).classList.add('d-none');
								}, 4500);

								return;
							}
							// =-=-=-=-=-

							if (document.querySelector('#checkoutBtn') != null)
								document.querySelector(
									'#checkoutBtn'
								).href = `/checkout?discount=${currentCode[0].code}`;

							if (
								document.querySelector(
									'ajax-cart [data-carttotal]'
								) !== null
							)
								document.querySelector(
									'ajax-cart [data-carttotal]'
								).innerHTML = `
								<del class="text-gray-400 fw-semibold me-1">${self.formatMoney(
									self.couponCodeData.totalPrice
								)}</del>
								<span class="money">${self.formatMoney(
									self.couponCodeData.totalDiscountedPrice,
									true
								)}</span>
							`;
						} else {
							self.clearCouponCodeStorage();

							self.couponCodeData.totalDiscount = null;
							self.couponCodeData.totalPrice = null;
							self.couponCodeData.totalDiscountedPrice = null;
							self.couponCodeData.nonApplicable = null;

							self.couponCodeData.hasError = true;
							self.couponCodeData.loading = false;
							if (document.querySelector('ajax-cart'))
								document
									.querySelector('ajax-cart')
									.setAttribute('updating', false);

							if (document.querySelector('#checkoutBtn') != null)
								document.querySelector('#checkoutBtn').href =
									'/checkout';

							if (
								document.querySelector(
									'ajax-cart [data-carttotal]'
								) !== null
							)
								document.querySelector(
									'ajax-cart [data-carttotal]'
								).innerHTML = `<span class="money">${self.formatMoney(
									window.globalVariables.cart.total_price,
									true
								)}</span>`;

							try {
                                //remove discount
								//await fetch('/discount/clear', {});
                                  const cartRes = await fetch('/cart.js', {});
                                  let cart = await cartRes.json();
                                  //console.log(cart);
                                  let token = cart.token;
                                  let v = {
                                    "cartId": "gid://shopify/Cart/" + token,
                                    "discountCodes": [
                                      ''
                                    ]
                                  };
                                  let q = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
                                    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                                      cart {
                                        discountCodes {
                                          code
                                          applicable
                                        }
                                      }
                                      userErrors {
                                        field
                                        message
                                      }
                                    }
                                  }`;
                                  const dRes = await fetch("/api/2025-07/graphql.json", {
                                    method:"POST",
                                    headers:{
                                      "Content-Type":"application/json",
                                    },
                                    body:JSON.stringify({
                                      query:q,
                                      variables:v
                                    })
                                  });
							} catch (e) {
								console.log(e);
							}

							setTimeout(() => {
								self.couponCodeData.hasError = false;

								if (self.querySelector('.text-danger') !== null)
									self.querySelector(
										'.text-danger'
									).classList.add('d-none');
							}, 3500);
						}
            })
            .finally(async () => {
						self.couponCodeData.loading = false;
						if (document.querySelector('ajax-cart'))
							document
								.querySelector('ajax-cart')
								.setAttribute('updating', false);

						if (obj.querySelector('.btn-apply') !== null) {
							obj.querySelector('.btn-apply').classList.remove(
								'is-loading'
							);
						}

						// Cover coupon code "Buy 1 get 1" type
						if (self.couponCodeData.nonApplicable !== null) {
							obj.renderDefaultHTML(
								self.couponCodeData.nonApplicable
							);
						} else {
							/*try {
								await fetch(
									`/discount/${self.couponCodeData.codeFound}`,
									{}
								);
							} catch (e) {
								console.log(e);
							}*/

							obj.renderHTML();

							if (document.querySelector('ajax-cart') !== null)
								document
									.querySelector('ajax-cart')
									.getCartData(null, false);
						}
					});
            });
          } catch (error) {
            console.log(error); 
          }
        });
      }
	}

	formatMoney(value, decimals = false) {
		const moneyFormat =
			decimals == false ? '${{amount_no_decimals}}' : '${{amount}}';
		return this.shopifyFormatMoney(value, moneyFormat);
	}

	shopifyFormatMoney(cents, format) {
		if (typeof cents == 'string') {
			cents = cents.replace('.', '');
		}

		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format;

		function defaultOption(opt, def) {
			return typeof opt == 'undefined' ? def : opt;
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.'),
				dollars = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				),
				cents = parts[1] ? decimal + parts[1] : '';

			return dollars + cents;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	eventsHandler() {
		if (this.querySelector('#code-submission-form') !== null) {
			this.querySelector('#code-submission-form').addEventListener(
				'submit',
				(e) => {
					e.preventDefault();
                    let obj = this;
					this.clearCouponCode().then(function() {

    					obj.couponCodeData.codeInput =
    						e.target.querySelector('input').value;
    
    					obj.applyCouponCode();
                    });
				}
			);
		}

		if (this.querySelector('#clear-coupon-code') !== null) {
			this.querySelector('#clear-coupon-code').addEventListener(
				'click',
				(e) => {
					e.preventDefault();
                    let obj = this;
					this.clearCouponCode().then(function() {

    					document.querySelector(
    						'ajax-cart [data-carttotal]'
    					).innerHTML = `<span class="money">${obj.formatMoney(
    						window.globalVariables.cart.total_price,
    						true
    					)}</span>`;
                    });
				}
			);
		}
	}

	renderHTML() {
		if (this.couponCodeData.codeFound == null) {
			let errorOutput = this.couponCodeData.hasError
				? `<div class="text-center font-size-sm text-danger mt-1">${this.couponCodeData.errorMessage}</div>`
				: '';

			this.innerHTML = `
				<div class="discount-code-wrapper text-start mb-3 ${this.isHidden}">
					<form id="code-submission-form" class="input-group">
						<input placeholder="${this.placeholder}" autocomplete="off" type="text" class="form-control">

						<div class="input-group-append">
							<button class="btn btn-sm btn-primary btn-not-round btn-apply">
								<span class="apply">Apply</span>
								<span class="spinner" role="status" aria-hidden="true"></span>
							</button>
						</div>
					</form>
					
					<div class="text-center leading-sm text-sm text-danger mt-2">${errorOutput}</div>
				</div>
			`;
		}

		if (
			this.couponCodeData.codeFound !== null &&
			this.couponCodeData.totalDiscount > 0
		) {
			this.innerHTML = `
				<div class="d-flex discount-applied-row justify-content-between mb-2">
					<a href="#" id="clear-coupon-code" class="coupon-wrap d-flex align-items-center bg-primary ps-2 pe-1 me-3 rounded-3 text-white fw-semibold">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="17" height="17" class="me-2">
							<path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill="black"></path>
							<path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z" fill="white"></path>
						</svg>
			
						<span class="font-size-sm text-uppercase fw-semibold me-1 -mb-2">${
							this.couponCodeData.codeInput
						}</span>
						
						<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
					</a>
					<div>
						<span class="fw-semibold font-size-md ls-sm">Discount: </span>
						<span class="fw-bold">${this.formatMoney(
							this.couponCodeData.totalDiscount
						)}</span>
					</div>
				</div>
			`;
		}

		this.eventsHandler();
	}

	renderDefaultHTML(notification) {
		this.innerHTML = `
			<div class="discount-code-wrapper text-start mb-3 ${this.isHidden}">
				<form id="code-submission-form" class="input-group">
					<input placeholder="${this.placeholder}" autocomplete="off" type="text" class="form-control">

					<div class="input-group-append">
						<button class="btn btn-sm btn-primary btn-not-round btn-apply">
							<span class="apply">Apply</span>
							<span class="spinner" role="status" aria-hidden="true"></span>
						</button>
					</div>
				</form>

				<div class="text-center font-size-sm text-danger mt-2">${notification}</div>
			</div>
		`;

		this.eventsHandler();
	}

	connectedCallback() {
		this.renderHTML();

		document.addEventListener('cart:updated', () => {
			this.applyCouponCode();
		});
	}
}

customElements.define('coupon-code-form', CouponCodeForm);
